const baseUrl = "https://www.system32.cloud";

export const siteConfig = {
  name: "System32",
  baseUrl,
  email: "mail@system32.cloud",
  phoneDisplay: "+45 26 66 22 64",
  phoneHref: "+4526662264",
  cvr: "39364085",
  addressLines: ["Hallingparken 26, 2 tv", "2660 Brøndby Strand"],
  linkedinUrl: "https://www.linkedin.com/company/system32-cloud",
  logoUrl: `${baseUrl}/sys3222.png`,
  url: (path = "") => `${baseUrl}${path}`,
};
